import { Button, Card, Grid, Icon, IconButton, Badge, Menu, MenuItem, Paper, Divider, ClickAwayListener } from "@mui/material";
import NotificationsIcon from "@mui/icons-material/Notifications";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { setDarkMode, setMiniSidenav, useMaterialUIController } from "context";
import { useMinimizedWindows } from "context/MinimizedWindowsContext";
import { useUser } from "context/UserContext";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import PropTypes from "prop-types";
import React, { useEffect, useMemo, useState } from "react";
import { getEnums } from "utils/Enums";
import { get, postNoResponse } from "utils/WebService";
import routes from "routes";
import { COR_MENU, clarear, comOpacidade, mapearCoresDasTelas } from "utils/CoresMenu";
import MDSnackbar from "components/MDSnackbar";
import SolicitacoesRecusadasDialog from "views/umc/filaSolicitacoes/SolicitacoesRecusadasDialog";
import { ESCURO } from "assets/coresTema";

// Avisos de recusa já mostrados nesta sessão (o aviso só reaparece quando há novidade)
const CHAVE_RECUSAS_VISTAS = "notifRecusasVistas";
const CHAVE_COBRANCA_VISTA = "notifUltimaCobrancaVista";

// Rota do menu pela key, em qualquer nível (seção > submenu > tela)
const buscarRota = (lista, key) => {
    for (const r of lista || []) {
        if (r.key === key && r.component) return r;
        const achada = buscarRota(r.collapse, key);
        if (achada) return achada;
    }
    return null;
};

// Por usuário: quem entrar depois na mesma aba do navegador recebe os próprios avisos
const chaveDoUsuario = (chave) => {
    try {
        return `${chave}_${sessionStorage.getItem("userId") || ""}`;
    } catch (e) {
        return chave;
    }
};
const lerSessao = (chave) => {
    try {
        const valor = sessionStorage.getItem(chaveDoUsuario(chave));
        return valor === null ? null : Number(valor);
    } catch (e) {
        return null;
    }
};
const gravarSessao = (chave, valor) => {
    try {
        sessionStorage.setItem(chaveDoUsuario(chave), String(valor));
    } catch (e) {
        // sem sessionStorage: o aviso só reaparece
    }
};


export default function SystemWrapper({
    tabs,
    closeTab,
    handleSidenavMenus, onPageSelect }) {

    const [tabValue, setTabValue] = useState(tabs.length > 0 ? tabs[tabs.length - 1].key : "");

    const [controller, dispatch] = useMaterialUIController();
    const { darkMode, miniSidenav } = controller;

    // Cada aba segue a cor da seção do menu a que a tela pertence (ex.: Importação de Remessa -> Suporte);
    // telas fora do menu (Home etc.) usam a cor do menu lateral
    const coresDasTelas = useMemo(() => mapearCoresDasTelas(routes), []);

    const { minimizedWindows, restoreWindow, closeWindow, registerTabSwitcher } = useMinimizedWindows();
    const [minimizedMenuOpen, setMinimizedMenuOpen] = useState(false);
    const totalMinimizadas = minimizedWindows.length;

    useEffect(() => {
        registerTabSwitcher((targetTabKey) => {
            if (targetTabKey) {
                setTabValue(targetTabKey);
            }
        });
    }, [registerTabSwitcher]);

    const { userId,
        setUserPerfils,
        setUserName,
        setUserEmail,
        userFunctionalities,
        setUserFunctionalities,
        setUserAtivo,
        setUserId,
        setMotivoEncerramentoEnum,
        setProcessoPessoaTipo,
        setProcessoStatus,
        setProfileType,
        setRelacaoJuridico,
        setRoboEditalStatus,
        setRoboEditalWibsStatus,
        setStatusCasoProcessual,
        setTipoCasoEnum,
        setTipoComplementoJusticaEnum,
        setTipoIndiceEnum,
        setTipoJusticaEnum,
        setTipoPessoaEnum,
        setTipoPartesEnum,
        setFonteMovimentacaoEnum,
        setTipoMovimentacaoEnum,
        setStatusProcesso,
        setStatusPrazoEnum,
        setSistemasEnum,
        setUserGestor,
        setTipoEventoEnum,
        setTipoPerfilEnum,
        setTipoFiltroAgendaEnum,
        setTipoAgendaEnum,
        setTipoSistemaEnum,
        setTipoDocumentoProcessoEnum
    } = useUser();

    async function fetchEnums() {
        const enumsMap = await getEnums();

        if (enumsMap) {
            setMotivoEncerramentoEnum(enumsMap.motivoEncerramentoEnum || []);
            setProcessoPessoaTipo(enumsMap.processoPessoaTipo || []);
            setProcessoStatus(enumsMap.processoStatus || []);
            setProfileType(enumsMap.profileType || []);
            setRelacaoJuridico(enumsMap.relacaoJuridico || []);
            setRoboEditalStatus(enumsMap.roboEditalStatus || []);
            setRoboEditalWibsStatus(enumsMap.roboEditalWibsStatus || []);
            setStatusCasoProcessual(enumsMap.statusCasoProcessual || []);
            setSistemasEnum(enumsMap.sistemasEnum || []);
            setTipoCasoEnum(enumsMap.tipoCasoEnum || []);
            setTipoComplementoJusticaEnum(enumsMap.tipoComplementoJusticaEnum || []);
            setTipoIndiceEnum(enumsMap.tipoIndiceEnum || []);
            setTipoJusticaEnum(enumsMap.tipoJusticaEnum || []);
            setTipoPessoaEnum(enumsMap.tipoPessoaEnum || [])
            setTipoPartesEnum(enumsMap.tipoPartesEnum || [])
            setFonteMovimentacaoEnum(enumsMap.fonteMovimentacaoEnum || [])
            setTipoMovimentacaoEnum(enumsMap.tipoMovimentacaoEnum || [])
            setStatusProcesso(enumsMap.statusProcesso || [])
            setStatusPrazoEnum(enumsMap.statusPrazoEnum || [])
            setTipoEventoEnum(enumsMap.tipoEventoEnum || [])
            setTipoPerfilEnum(enumsMap.tipoPerfilEnum || [])
            setTipoFiltroAgendaEnum(enumsMap.tipoFiltroAgendaEnum || [])
            setTipoAgendaEnum(enumsMap.tipoAgendaEnum || [])
            setTipoSistemaEnum(enumsMap.tipoSistemaEnum || [])
            setTipoDocumentoProcessoEnum(enumsMap.tipoDocumentoProcessoEnum || [])
        }
    }

    useEffect(() => {
        get('/users/by-token')
            .then(({ id, funcionalidades }) => {
                if (id !== null) {
                    sessionStorage.setItem('userId', id);
                    fetchEnums();
                    setUserId(id)
                    handleSidenavMenus(funcionalidades)
                    setUserFunctionalities(funcionalidades);
                    get('/users/by-id/'.concat(id))
                        .then(({ id, perfils, email, nome, ativo, temaDark, gestor }) => {
                            setUserPerfils(perfils);
                            setUserName(nome);
                            setUserEmail(email);
                            setUserAtivo(ativo);
                            setUserId(id);
                            setDarkMode(dispatch, temaDark);
                            setUserGestor(gestor)
                            sessionStorage.setItem('tema', temaDark);
                        });
                }

            }).catch(() => null);

    }, []);

    // Se as permissões mudarem em tempo de execução, atualizamos o menu sem precisar relogar!
    useEffect(() => {
        if (userFunctionalities && userFunctionalities.length > 0) {
            handleSidenavMenus(userFunctionalities);
        }
    }, [userFunctionalities]);

    function handleSetTabValue(newValue) {
        setTabValue(newValue);
    }

    const [anchorNotif, setAnchorNotif] = useState(null);
    const handleOpenNotif = (event) => {
        setAnchorNotif(event.currentTarget);
        fetchNotifications();
    };
    const handleCloseNotif = () => setAnchorNotif(null);

    const handleThemeToggle = () => {
        const nextMode = !darkMode;
        sessionStorage.setItem('tema', nextMode);
        setDarkMode(dispatch, nextMode);

        if (userId) {
            const body = {
                id: userId,
                temaDark: nextMode
            };
            postNoResponse("/users/save-theme", body).catch(() => null);
        }
    };

    const [notifResume, setNotifResume] = useState(null);
    const [recusadasOpen, setRecusadasOpen] = useState(false);
    const [avisoRecusa, setAvisoRecusa] = useState("");

    // Fila de Solicitações: avisa (uma vez por novidade na sessão) quando uma solicitação do usuário é recusada
    // ou quando o suporte cobra a posição dele
    const avisarRecusas = (res) => {
        const total = res?.totalSolicitacoesRecusadas || 0;
        const ultimaCobranca = res?.ultimaCobrancaSolicitacaoMillis || 0;
        const recusasVistas = lerSessao(CHAVE_RECUSAS_VISTAS);
        const cobrancaVista = lerSessao(CHAVE_COBRANCA_VISTA) || 0;
        if (total > 0 && ultimaCobranca > cobrancaVista) {
            setAvisoRecusa(`O suporte está cobrando a sua posição em ${total === 1 ? "1 solicitação recusada" : `${total} solicitações recusadas`}.`);
        } else if (total > 0 && (recusasVistas === null || total > recusasVistas)) {
            setAvisoRecusa(`${total === 1 ? "1 solicitação sua foi recusada" : `${total} solicitações suas foram recusadas`} pelo suporte e ${total === 1 ? "aguarda" : "aguardam"} a sua posição (ciente ou reenviar).`);
        }
        gravarSessao(CHAVE_RECUSAS_VISTAS, total);
        gravarSessao(CHAVE_COBRANCA_VISTA, Math.max(ultimaCobranca, cobrancaVista));
    };

    const fetchNotifications = () => {
        get('/notifications/resume')
            .then((res) => {
                setNotifResume(res);
                avisarRecusas(res);
            }).catch(() => null);
    };

    useEffect(() => {
        // Fetch inicial
        fetchNotifications();

        // Polling para atualização periódica (a cada 30 segundos)
        const intervalId = setInterval(() => {
            fetchNotifications();
        }, 30000);

        return () => clearInterval(intervalId); // Limpa o intervalo se o componente desmontar
    }, []);

    const urgentCount = notifResume?.totalSolicitacoesUrgentes || 0;
    const todayCount = notifResume?.totalEventosHoje || 0;
    const delayedCount = notifResume?.totalEventosAtrasados || 0;
    const fichasHoje = notifResume?.totalFichasHoje || 0;
    const fichasAtrasadas = notifResume?.totalFichasAtrasadas || 0;
    const otherCount = (notifResume?.totalSolicitacoes || 0) + (notifResume?.totalEventos || 0) - urgentCount - todayCount - delayedCount;
    // Solicitações de devolução/migração recusadas que aguardam a posição do usuário (e quantas o suporte já cobrou)
    const recusadasCount = notifResume?.totalSolicitacoesRecusadas || 0;
    const recusadasCobradas = notifResume?.totalSolicitacoesRecusadasCobradas || 0;
    // Fila de Solicitações do suporte (só para quem atende a fila): aguardando análise e há mais de 3 dias
    const atendeFilaSuporte = notifResume?.atendeFilaSuporte === true;
    const filaSuporteCount = notifResume?.totalFilaSuporte || 0;
    const filaSuporteAtrasadas = notifResume?.totalFilaSuporteAtrasadas || 0;

    const hasUnread = urgentCount > 0 || todayCount > 0 || delayedCount > 0 || otherCount > 0 || fichasHoje > 0 || fichasAtrasadas > 0
        || recusadasCount > 0 || filaSuporteCount > 0;

    let pulseDuration = "none";
    if (hasUnread) {
        if (urgentCount > 0 || delayedCount > 0 || fichasAtrasadas > 0 || recusadasCount > 0 || filaSuporteAtrasadas > 0) pulseDuration = "0.8s"; // Urgente/Atrasado/Recusa = rápido
        else if (filaSuporteCount > 0) pulseDuration = "1.5s"; // Fila do suporte com pedidos = moderado
        else if (todayCount > 0 || fichasHoje > 0) pulseDuration = "1.5s"; // Hoje = moderado
        else pulseDuration = "3s"; // Demais = lento
    }

    useEffect(() => {
        // Ignora no ambiente de desenvolvimento para evitar travamentos com o hot-reload do webpack/yarn start
        if (process.env.NODE_ENV === "development" || window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") {
            return;
        }

        const handleBeforeUnload = (e) => {
            // Em formato ERP é mais seguro barrar qualquer tentativa de fechamento global
            // Assim engloba edições em andamento perfeitamente sem risco do usuário perder trabalho!
            e.preventDefault();
            e.returnValue = "Existem alterações não salvas ou tarefas pendentes. Deseja realmente sair?";
            return e.returnValue;
        };

        window.addEventListener("beforeunload", handleBeforeUnload);
        return () => window.removeEventListener("beforeunload", handleBeforeUnload);
    }, []);

    // Set custom page selector on window for external triggers (like Monitoria link)
    useEffect(() => {
        window.onPageSelectCustom = onPageSelect;
        return () => {
            window.onPageSelectCustom = null;
        };
    }, [onPageSelect]);

    // Periodical user activity heartbeat
    const sendActivityHeartbeat = () => {
        const token = sessionStorage.getItem('user');
        if (!token) return;

        const activeTabObj = tabs.find(t => t.key === tabValue);
        let actionName = activeTabObj ? activeTabObj.name : "Navegando no Sistema";
        
        let idDevedor = null;
        if (tabValue === "baseDeDados" || tabValue === "fila-trabalho") {
            idDevedor = sessionStorage.getItem('activeDevedorId') || null;
            if (idDevedor) {
                const devedorNome = sessionStorage.getItem('activeDevedorNome') || "Ficha";
                actionName = tabValue === "fila-trabalho" ? `Fila de Trabalho: ${devedorNome}` : `Acessando Ficha: ${devedorNome}`;
            } else {
                actionName = tabValue === "fila-trabalho" ? "Aguardando Fila de Trabalho" : "Visualizando Base de Dados";
            }
        }

        postNoResponse('/users/atividade', {
            ultimaAcao: actionName,
            idDevedor: idDevedor
        }).catch(() => null);
    };

    useEffect(() => {
        sendActivityHeartbeat();

        const intervalId = setInterval(() => {
            sendActivityHeartbeat();
        }, 45000); // 45s heartbeat

        const handleSessionUpdate = () => {
            sendActivityHeartbeat();
        };
        window.addEventListener('sessionStorageUpdate', handleSessionUpdate);

        return () => {
            clearInterval(intervalId);
            window.removeEventListener('sessionStorageUpdate', handleSessionUpdate);
        };
    }, [tabValue]);

    const renderNotifMenu = (
        <Menu
            anchorEl={anchorNotif}
            open={Boolean(anchorNotif)}
            onClose={handleCloseNotif}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
            sx={{ mt: 1 }}
        >
            {recusadasCount > 0 && (
                <MenuItem onClick={() => { handleCloseNotif(); setRecusadasOpen(true); }}
                    sx={{ p: 1.5, display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                    <MDBox display="flex" alignItems="center" mb={0.5}>
                        <Icon fontSize="inherit" sx={{ mr: 1, color: recusadasCobradas > 0 ? 'error.main' : 'warning.main', fontSize: '14px' }}>
                            assignment_late
                        </Icon>
                        <MDTypography variant="button" fontWeight="bold" sx={{ fontSize: '10px' }}>
                            Solicitações Recusadas
                        </MDTypography>
                    </MDBox>
                    <MDTypography variant="caption" color="text" sx={{ fontSize: '10px', pl: 2.5 }}>
                        {recusadasCount === 1 ? "1 aguarda" : `${recusadasCount} aguardam`} a sua posição (ciente ou reenviar).{" "}
                        {recusadasCobradas > 0 && <strong style={{ color: '#F44335' }}>({recusadasCobradas} COBRADA{recusadasCobradas > 1 ? "S" : ""})</strong>}
                    </MDTypography>
                </MenuItem>
            )}

            {atendeFilaSuporte && (
                <MenuItem onClick={() => {
                    handleCloseNotif();
                    const filaRoute = buscarRota(routes, "fila-solicitacoes");
                    if (filaRoute) {
                        onPageSelect(filaRoute);
                    }
                }} sx={{ p: 1.5, display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                    <MDBox display="flex" alignItems="center" mb={0.5}>
                        <Icon fontSize="inherit" sx={{ mr: 1, color: filaSuporteAtrasadas > 0 ? 'error.main' : (filaSuporteCount > 0 ? 'warning.main' : 'info.main'), fontSize: '14px' }}>
                            assignment_returned
                        </Icon>
                        <MDTypography variant="button" fontWeight="bold" sx={{ fontSize: '10px' }}>
                            Fila de Solicitações (Suporte)
                        </MDTypography>
                    </MDBox>
                    <MDTypography variant="caption" color="text" sx={{ fontSize: '10px', pl: 2.5 }}>
                        {filaSuporteCount === 0 ? "Nenhuma devolução/migração aguardando análise."
                            : `${filaSuporteCount} ${filaSuporteCount === 1 ? "devolução/migração aguarda" : "devoluções/migrações aguardam"} análise.`}{" "}
                        {filaSuporteAtrasadas > 0 && (
                            <strong style={{ color: '#F44335' }}>({filaSuporteAtrasadas} HÁ MAIS DE 3 DIAS)</strong>
                        )}
                    </MDTypography>
                </MenuItem>
            )}

            <MenuItem onClick={() => {
                handleCloseNotif();
                const flatRoutes = routes.flatMap(r => r.collapse ? r.collapse : r);
                const solRoute = flatRoutes.find(r => r.key === "solicitacoesSystem");
                if (solRoute) {
                    onPageSelect(solRoute);
                }
            }} sx={{ p: 1.5, display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                <MDBox display="flex" alignItems="center" mb={0.5}>
                    <Icon fontSize="inherit" sx={{ mr: 1, color: urgentCount > 0 ? 'error.main' : 'warning.main', fontSize: '14px' }}>
                       assignment
                    </Icon>
                    <MDTypography variant="button" fontWeight="bold" sx={{ fontSize: '10px' }}>
                        Solicitações Pendentes
                    </MDTypography>
                </MDBox>
                <MDTypography variant="caption" color="text" sx={{ fontSize: '10px', pl: 2.5 }}>
                   Você possui {notifResume?.totalSolicitacoes || 0} solicitações.{" "}
                   {urgentCount > 0 && <strong style={{ color: '#F44335' }}>({urgentCount} URGENTE)</strong>}
                </MDTypography>
            </MenuItem>

            {(notifResume?.hasProcessos !== false) && (
            <MenuItem onClick={() => {
                handleCloseNotif();
                const homeRoute = tabs.find(t => t.key === "home");
                if (homeRoute) {
                    onPageSelect(homeRoute);
                }
            }} sx={{ p: 1.5, display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                <MDBox display="flex" alignItems="center" mb={0.5}>
                    <Icon fontSize="inherit" sx={{ mr: 1, color: (delayedCount > 0) ? 'error.main' : (todayCount > 0 ? 'warning.main' : 'info.main'), fontSize: '14px' }}>
                       event
                    </Icon>
                    <MDTypography variant="button" fontWeight="bold" sx={{ fontSize: '10px' }}>
                        Compromissos / Eventos
                    </MDTypography>
                </MDBox>
                <MDTypography variant="caption" color="text" sx={{ fontSize: '10px', pl: 2.5 }}>
                   Total de {notifResume?.totalEventos || 0} eventos na pauta.{" "}
                   {todayCount > 0 && <strong style={{ color: '#FB8C00' }}>({todayCount} DO DIA) </strong>}
                   {delayedCount > 0 && <strong style={{ color: '#F44335' }}>({delayedCount} ATRASADO) </strong>}
                </MDTypography>
            </MenuItem>
            )}

            {(notifResume?.hasCobranca !== false) && (
            <MenuItem onClick={() => {
                handleCloseNotif();
                const homeRoute = tabs.find(t => t.key === "home");
                if (homeRoute) {
                    onPageSelect(homeRoute);
                }
            }} sx={{ p: 1.5, display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                <MDBox display="flex" alignItems="center" mb={0.5}>
                    <Icon fontSize="inherit" sx={{ mr: 1, color: fichasAtrasadas > 0 ? 'error.main' : (fichasHoje > 0 ? 'warning.main' : 'info.main'), fontSize: '14px' }}>
                       contact_phone
                    </Icon>
                    <MDTypography variant="button" fontWeight="bold" sx={{ fontSize: '10px' }}>
                        Fichas Agendadas
                    </MDTypography>
                </MDBox>
                <MDTypography variant="caption" color="text" sx={{ fontSize: '10px', pl: 2.5 }}>
                   Você possui {fichasHoje || 0} fichas para hoje.{" "}
                   {fichasAtrasadas > 0 && <strong style={{ color: '#F44335' }}>({fichasAtrasadas} ATRASADAS) </strong>}
                </MDTypography>
            </MenuItem>
            )}
        </Menu>
    );

    function handleCloseTab(tab, tabIndex) {
        let tabKey = tab.key;
        let nextKey = tabs[tabIndex + 1]?.key;
        let previousKey = tabs[tabIndex - 1]?.key;
        if (tabKey === tabValue) {
            if (nextKey) handleSetTabValue(nextKey);
            else if (previousKey) handleSetTabValue(previousKey);
        }
        closeTab(tab);
    }

    useEffect(() => {
        if (tabs.length > 0) {
            const activeTab = tabs.find(tab => tab.active === true);
            if (activeTab) {
                setTabValue(activeTab.key);
            } else {
                setTabValue(tabs[tabs.length - 1].key);
            }
        } else {
            setTabValue("");
        }
    }, [tabs]);

    return (
        <DashboardLayout>
            <Grid container>
                <MDBox display="flex" justifyContent="space-between" alignItems="center" width="100%" sx={{ p: "0.24rem", mb: -0.2 }}>
                    <MDBox display="flex" justifyContent="start" sx={{ overflowX: "auto", overflowY: "hidden", alignItems: "center", flex: 1, pt: "4px" }}>
                        <MDBox display="block" mr={1}>
                            <IconButton
                                size="small"
                                disableRipple
                                color="inherit"
                                onClick={() => setMiniSidenav(dispatch, !controller.miniSidenav)}
                            >
                                <Icon color="text" fontSize="medium">
                                    {controller.miniSidenav ? "menu_open" : "menu"}
                                </Icon>
                            </IconButton>
                        </MDBox>
                        {tabs.map((tab, idx) => {
                            if (tab.component) {
                                const isSelected = tab.key === tabValue;
                                // No fundo escuro os tons das seções ficam apagados: clareia antes de aplicar
                                const corBase = coresDasTelas[tab.key] || COR_MENU;
                                const corAba = darkMode ? clarear(corBase, 0.35) : corBase;
                                const corMenu = (opacidade) => comOpacidade(corAba, opacidade);
                                return (
                                    <Card
                                        key={tab.key + "-" + idx}
                                        sx={{
                                            marginRight: 0.5,
                                            minWidth: "auto",
                                            borderRadius: "8px 8px 0 0",
                                            // Aba ativa: sublinhado na cor da seção, degradê suave e sombra leve; as demais só um traço fraco
                                            background: isSelected
                                                ? `linear-gradient(180deg, ${corMenu(darkMode ? 0.08 : 0.02)} 0%, ${corMenu(darkMode ? 0.3 : 0.14)} 100%)`
                                                : "transparent",
                                            boxShadow: isSelected ? `0 -1px 6px -1px ${corMenu(darkMode ? 0.5 : 0.35)}` : "none",
                                            borderBottom: `3px solid ${isSelected ? corAba : corMenu(darkMode ? 0.55 : 0.32)}`,
                                            transition: "all 0.2s ease-in-out",
                                            "&:hover": isSelected ? {} : {
                                                background: corMenu(darkMode ? 0.16 : 0.06),
                                                borderBottomColor: corMenu(0.6),
                                            }
                                        }}>
                                        <MDBox display="flex" alignItems="center" px={0.5}>
                                            <Button
                                                fullWidth
                                                sx={{
                                                    padding: "4px 8px",
                                                    minWidth: "auto",
                                                    minHeight: "28px",
                                                    textTransform: "none",
                                                    display: "flex",
                                                    alignItems: "center"
                                                }}
                                                onClick={() => handleSetTabValue(tab.key)}>
                                                <MDTypography
                                                    variant="body2"
                                                    fontWeight={isSelected ? "medium" : "regular"}
                                                    color="text"
                                                    sx={{ whiteSpace: "nowrap", fontSize: 12 }}>
                                                    {tab.name}
                                                </MDTypography>
                                            </Button>
                                            {tabs.length > 1 && tab.key !== 'home' && (
                                                <IconButton
                                                    size="small"
                                                    sx={{
                                                        p: "2px",
                                                        width: "22px",
                                                        height: "22px",
                                                        ml: 0.5,
                                                    }}
                                                    onClick={() => handleCloseTab(tab, idx)}>
                                                    <MDTypography variant="body1" lineHeight={1}>
                                                        <Icon color="light" sx={{ fontSize: "16px !important" }}>close</Icon>
                                                    </MDTypography>
                                                </IconButton>
                                            )}
                                        </MDBox>
                                    </Card>
                                );
                            }
                            return null;
                        })}
                    </MDBox>

                    <MDBox display="flex" alignItems="center" mr={2}>
                        <IconButton
                            size="small"
                            disableRipple
                            color="inherit"
                            onClick={handleOpenNotif}
                            sx={{
                                p: 0,
                                "& .MuiBadge-badge": {
                                    height: 11,
                                    width: 11,
                                    borderRadius: "50%",
                                    border: "2px solid #fff",
                                    boxShadow: "0px 0px 4px rgba(0,0,0,0.3)",
                                    animation: hasUnread ? `pulse ${pulseDuration} infinite ease-in-out` : "none",
                                },
                                "@keyframes pulse": {
                                    "0%": {
                                        boxShadow: darkMode ? "0 0 0 0 rgba(255, 80, 80, 0.9)" : "0 0 0 0 rgba(244, 67, 54, 0.7)",
                                    },
                                    "70%": {
                                        boxShadow: darkMode ? "0 0 0 8px rgba(255, 80, 80, 0)" : "0 0 0 8px rgba(244, 67, 54, 0)",
                                    },
                                    "100%": {
                                        boxShadow: darkMode ? "0 0 0 0 rgba(255, 80, 80, 0)" : "0 0 0 0 rgba(244, 67, 54, 0)",
                                    },
                                },
                                "&:hover svg": {
                                    animation: "ring 1.5s ease-in-out",
                                },
                                "@keyframes ring": {
                                    "0%": { transform: "rotate(0deg)" },
                                    "15%": { transform: "rotate(15deg)" },
                                    "30%": { transform: "rotate(-10deg)" },
                                    "45%": { transform: "rotate(5deg)" },
                                    "60%": { transform: "rotate(-5deg)" },
                                    "75%": { transform: "rotate(0deg)" },
                                    "100%": { transform: "rotate(0deg)" }
                                }
                            }}
                        >
                            <Badge variant="dot" color="error" invisible={!hasUnread}>
                                <NotificationsIcon sx={{ color: "text.main", fontSize: "20px !important" }} />
                            </Badge>
                        </IconButton>
                        {renderNotifMenu}
                        <SolicitacoesRecusadasDialog open={recusadasOpen} onClose={() => setRecusadasOpen(false)} onChanged={fetchNotifications} />
                        <MDSnackbar
                            color="warning"
                            icon="assignment_late"
                            title="Solicitação recusada"
                            autoHideDuration={15000}
                            content={
                                <MDBox>
                                    {avisoRecusa}
                                    <MDBox mt={1}>
                                        <MDButton size="small" variant="gradient" color="warning" onClick={() => { setAvisoRecusa(""); setRecusadasOpen(true); }}>
                                            Responder agora
                                        </MDButton>
                                    </MDBox>
                                </MDBox>
                            }
                            open={!!avisoRecusa}
                            onClose={(e, motivo) => { if (motivo !== "clickaway") setAvisoRecusa(""); }}
                            close={() => setAvisoRecusa("")}
                            bgWhite
                        />
                    </MDBox>
                </MDBox>
                <MDBox
                    width="100%"
                    height="auto">
                    {tabs.map((tab, idx) => {
                        if (tab.component)
                            return (
                                <div
                                    style={{ width: "100%", paddingLeft: 4 }}
                                    key={tab.key + "-" + idx}
                                    role="tabpanel"
                                    hidden={tabValue !== tab.key}
                                    id={`tabpanel-${tab.key}`}
                                    aria-labelledby={`tab-${tab.key}`}
                                >
                                    {React.cloneElement(tab.component, { onPageSelect })}
                                </div>
                            );
                        return null;
                    })}
                </MDBox>

            </Grid>

            {/* Botão e Menu Global de Telas Minimizadas (ao lado do SAIR em todas as telas) */}
            {totalMinimizadas > 0 && (
                <ClickAwayListener onClickAway={() => setMinimizedMenuOpen(false)}>
                    <MDBox
                        sx={{
                            position: "fixed",
                            bottom: 14,
                            left: miniSidenav ? 106 : 260,
                            zIndex: 9999,
                            transition: "left 200ms ease-in-out",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            pointerEvents: "auto"
                        }}
                    >
                        {/* Popover / Card flutuante com a lista das janelas minimizadas */}
                        {minimizedMenuOpen && (
                            <Paper
                                elevation={6}
                                sx={{
                                    mb: 1,
                                    minWidth: 290,
                                    maxWidth: 360,
                                    borderRadius: "10px",
                                    backgroundColor: darkMode ? ESCURO.cartao : "#ffffff",
                                    color: darkMode ? "#ffffff" : "#1a2035",
                                    border: darkMode ? `1px solid ${ESCURO.borda}` : "1px solid #e0e0e0",
                                    boxShadow: darkMode ? "0 8px 24px rgba(0,0,0,0.6)" : "0 8px 24px rgba(0,0,0,0.15)",
                                    p: 0.5,
                                    overflow: "hidden"
                                }}
                            >
                                <MDBox px={1.5} py={0.8} display="flex" alignItems="center" justifyContent="space-between">
                                    <MDBox display="flex" alignItems="center" gap={1}>
                                        <Icon fontSize="small" sx={{ color: darkMode ? "#90caf9" : "#1976d2" }}>layers</Icon>
                                        <MDTypography variant="button" fontWeight="bold" sx={{ color: darkMode ? "#ffffff" : "#1a2035", fontSize: "0.85rem" }}>
                                            Janelas Minimizadas ({totalMinimizadas})
                                        </MDTypography>
                                    </MDBox>
                                    <IconButton
                                        size="small"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setMinimizedMenuOpen(false);
                                        }}
                                        title="Esconder lista"
                                        sx={{ p: 0.5, color: darkMode ? "#bbb" : "#777", "&:hover": { color: darkMode ? "#fff" : "#1a2035" } }}
                                    >
                                        <Icon fontSize="small">keyboard_arrow_down</Icon>
                                    </IconButton>
                                </MDBox>

                                <Divider sx={{ my: 0.5, backgroundColor: darkMode ? ESCURO.hover : "#e0e0e0" }} />

                                {minimizedWindows.map((win) => (
                                    <MDBox
                                        key={win.id}
                                        onClick={() => {
                                            restoreWindow(win.id);
                                            setMinimizedMenuOpen(false);
                                        }}
                                        sx={{
                                            py: 1,
                                            px: 1.5,
                                            borderRadius: "8px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            cursor: "pointer",
                                            transition: "background 0.2s",
                                            "&:hover": {
                                                backgroundColor: darkMode ? "rgba(255,255,255,0.08)" : "rgba(26,115,232,0.08)"
                                            }
                                        }}
                                    >
                                        <MDBox display="flex" alignItems="center" gap={1.2}>
                                            <Icon sx={{ color: win.color || "#1A73E8", fontSize: "22px !important" }}>
                                                {win.icon || "aspect_ratio"}
                                            </Icon>
                                            <MDBox>
                                                <MDTypography variant="button" fontWeight="bold" sx={{ color: darkMode ? "#ffffff" : "#1a2035", fontSize: "0.83rem", display: "block" }}>
                                                    {win.title}
                                                </MDTypography>
                                                <MDTypography variant="caption" sx={{ color: darkMode ? "#bbb" : "#666", fontSize: "0.72rem", display: "block" }}>
                                                    {win.subtitle || "Clique para restaurar"}
                                                </MDTypography>
                                            </MDBox>
                                        </MDBox>
                                        <MDBox display="flex" alignItems="center" gap={0.5} onClick={(e) => e.stopPropagation()}>
                                            <IconButton
                                                size="small"
                                                onClick={() => {
                                                    restoreWindow(win.id);
                                                    setMinimizedMenuOpen(false);
                                                }}
                                                title="Restaurar Tela"
                                                sx={{ p: 0.5, color: win.color || "#1A73E8" }}
                                            >
                                                <Icon fontSize="small">open_in_full</Icon>
                                            </IconButton>
                                            <IconButton
                                                size="small"
                                                onClick={() => {
                                                    closeWindow(win.id);
                                                    if (totalMinimizadas <= 1) {
                                                        setMinimizedMenuOpen(false);
                                                    }
                                                }}
                                                title="Fechar definitivamente"
                                                sx={{ p: 0.5, color: darkMode ? "#bbb" : "#777", "&:hover": { color: "#f44336" } }}
                                            >
                                                <Icon fontSize="small">close</Icon>
                                            </IconButton>
                                        </MDBox>
                                    </MDBox>
                                ))}
                            </Paper>
                        )}

                        {/* Botão de Disparo com animação pulsante / piscante */}
                        <MDButton
                            variant={darkMode ? "contained" : "gradient"}
                            color="info"
                            size="small"
                            onClick={(e) => {
                                e.stopPropagation();
                                setMinimizedMenuOpen(prev => !prev);
                            }}
                            sx={{
                                px: 1.5,
                                py: 0.8,
                                borderRadius: "8px",
                                textTransform: "none",
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                                backgroundColor: darkMode ? ESCURO.cartao : undefined,
                                border: darkMode ? `1px solid ${ESCURO.borda}` : undefined,
                                color: "#ffffff",
                                animation: "pulseMinimized 2s infinite ease-in-out",
                                "@keyframes pulseMinimized": {
                                    "0%": {
                                        boxShadow: darkMode
                                            ? "0 0 0 0 rgba(33, 150, 243, 0.8), 0 4px 14px rgba(0,0,0,0.5)"
                                            : "0 0 0 0 rgba(26, 115, 232, 0.7), 0 4px 14px rgba(26,115,232,0.3)",
                                        transform: "scale(1)"
                                    },
                                    "50%": {
                                        boxShadow: darkMode
                                            ? "0 0 0 9px rgba(33, 150, 243, 0), 0 6px 18px rgba(0,0,0,0.6)"
                                            : "0 0 0 9px rgba(26, 115, 232, 0), 0 6px 18px rgba(26,115,232,0.45)",
                                        transform: "scale(1.03)"
                                    },
                                    "100%": {
                                        boxShadow: darkMode
                                            ? "0 0 0 0 rgba(33, 150, 243, 0), 0 4px 14px rgba(0,0,0,0.5)"
                                            : "0 0 0 0 rgba(26, 115, 232, 0), 0 4px 14px rgba(26,115,232,0.3)",
                                        transform: "scale(1)"
                                    }
                                },
                                "&:hover": {
                                    backgroundColor: darkMode ? ESCURO.hover : undefined,
                                    transform: "scale(1.05)",
                                    boxShadow: darkMode ? "0 6px 20px rgba(0,0,0,0.7)" : "0 6px 20px rgba(26,115,232,0.5)",
                                }
                            }}
                        >
                            <Badge
                                badgeContent={totalMinimizadas}
                                color="error"
                                sx={{
                                    "& .MuiBadge-badge": {
                                        right: -3,
                                        top: 2,
                                        fontSize: "0.7rem",
                                        height: "18px",
                                        minWidth: "18px",
                                        animation: "badgePulse 1.5s infinite ease-in-out",
                                        "@keyframes badgePulse": {
                                            "0%": { transform: "scale(1)" },
                                            "50%": { transform: "scale(1.18)" },
                                            "100%": { transform: "scale(1)" }
                                        }
                                    }
                                }}
                            >
                                <Icon sx={{ fontSize: "19px !important" }}>tab</Icon>
                            </Badge>
                            <MDTypography
                                variant="button"
                                fontWeight="bold"
                                sx={{
                                    color: "#ffffff !important",
                                    fontSize: "0.82rem",
                                    letterSpacing: "0.2px"
                                }}
                            >
                                Janelas Minimizadas
                            </MDTypography>
                            <Icon sx={{ fontSize: "18px !important", ml: 0.5 }}>
                                {minimizedMenuOpen ? "keyboard_arrow_down" : "keyboard_arrow_up"}
                            </Icon>
                        </MDButton>
                    </MDBox>
                </ClickAwayListener>
            )}
        </DashboardLayout>
    );
}

// Typechecking props for SystemWrapper
SystemWrapper.propTypes = {
    tabs: PropTypes.array.isRequired,
    closeTab: PropTypes.func.isRequired,
};
